module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1115.28a6e50d.png";